<kodit-page [showCardBlock]="showCardBlock">
  <kodit-table
    [tableConfig]="tableConfig"
    [items]="robaTable"
    [chipItems]="chipItems"
    [isTableLoading]="isLoading"
  >
  </kodit-table>
</kodit-page>
